module.exports = __webpack_public_path__ + "img/10.a8db9025.png";